module.exports = __webpack_public_path__ + "static/media/img_Benchmarking102.676e71f5.png";